module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<p>\n  <img src="/static/images/icon-info.gif" alt="Important Info" />\n  If your transactions haven\'t appeared, your CSV may not be recognised. Please\n  get in touch if you think this is not the case.\n</p>\n\n<div class="table-hook"></div>\n<div class="page-hook"></div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./epayment_import/templates/list.html
// module id = 202
// module chunks = 0